<template>
	<div class="card">
		<header class="card-header">
			<h3 class="card-title">Translators</h3>
		</header>
		<div class="card-body">

		</div>
	</div>
</template>

<script>
	export default {
		props: {
		},
		data() {
			return {
			}
		}
	}
</script>

<style scoped>

</style>
